<footer>
	<div class="container">
		<div class="row">
			<div class="col-md-4 ml-5 ml-sm-0">
				<div class="foot-about">
					<img loading="lazy" src="../../../../assets/images/logo.png">
					<p>Welcome To PhoneNation</p>
				</div>
			</div>
			<div class="col-md-4 ml-5 ml-sm-0" *ngIf="userType != 'guest'">
				<div class="links" *ngIf="isLogin != 0">
					<h4>Quick Links </h4>
					<ul>
						<li *ngFor="let link of footerDataUpper">
							<div>
								<a [routerLink]="[link.url]">{{link.text}}</a>
							</div>
						</li>
						<div style="display: none;" *ngIf="isFooterDown == 1">
							<li *ngFor="let link of footerDataDown">
								<div *ngIf="isFooterDown == 0">
									<a [routerLink]="[link.url]">{{link.text}}</a>
								</div>
							</li>
						</div>
						<div *ngIf="isFooterUp == 1">
							<li *ngFor="let link of footerDataDown">
								<div *ngIf="isFooterDown == 0">
									<a [routerLink]="[link.url]">{{link.text}}</a>
								</div>
							</li>
						</div>
						<li *ngIf="isFooterDown == 1">
							<div>
								<i class="fas fa-chevron-down" style="cursor: pointer;" (click)="showAllFooter()"></i>
							</div>
						</li>
						<li *ngIf="isFooterUp == 1">
							<div>
								<i class="fas fa-chevron-up" style="cursor: pointer;" (click)="showSomeFooter()"></i>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-md-4 ml-5 ml-sm-0" *ngIf="userType != 'guest'">
				<div class="links">
					<h4>Address </h4>
					<p>8 DUOS, OFFICE TOWER, REGUS<br> 1 Fraser St, Singapore 189350</p>
				</div>
				<div class="links mt-4">
					<h4>Contact Us </h4>
					<p>Whatsapp/ SMS: 9011 1239</p>
					<p>enquiry&#64;letsupgradeyourbusiness.com</p>
				</div>
			</div>


		</div>
		<!--row close-->
	</div><!-- container close-->

</footer>